import { SpeakingLessonCompleted } from '../features/speakingCompleted/speakingCompleted.tsx'

export function SpeakingCompletedPage() {
  return <SpeakingLessonCompleted />
}
